// extracted by mini-css-extract-plugin
export var colorSquare = "_q7-0";
export var danger = "_q7-5";
export var lightPink = "_q7-8";
export var neutralBlue = "_q7-7";
export var neutralYellow = "_q7-6";
export var normal = "_q7-1";
export var primary = "_q7-2";
export var primaryLight = "_q7-3";
export var solidBlack = "_q7-g";
export var solidGreen = "_q7-b";
export var solidLightBlue = "_q7-d";
export var solidNavy = "_q7-c";
export var solidOrange = "_q7-f";
export var solidPink = "_q7-e";
export var solidRed = "_q7-9";
export var solidYellow = "_q7-a";
export var success = "_q7-4";